import React, {ReactElement, useEffect, useState} from 'react';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import OfferCard from './OfferCard';
import {useHistory} from 'react-router';
import OfferModal from '../offers/offerModal';
import {getWithExpiry} from '../../core/localstorage-utils';
import {
  getAccessToken,
  getCouponPointsDetails,
  getPhoneNumber,
  setAllOffers,
} from '../../core/localstorage-data';
import {fetchOffers, offers} from '../../redux/offerSlice';
import {BackButtonAction} from '../../core/utils/string.util';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';

// import BarcodeScanner from './BarcodeScanner';

const Offers = (): ReactElement => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const myOffers = useAppSelector(offers);

  useEffect(() => {
    setPageName(pageName.offerDetailPage);

    dispatch(setAppBarTitle('My offers'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, []);
  const [allCoupons, setAllCoupons] = useState([] as any);
  const [showUnlockedModel, setShowUnlockedModel] = useState(false);
  const [unlockedOffer, setUnlockedOffer] = useState(null);

  // useEffect(() => {
  //   const parameters = {
  //     payload: {mobileNumber: getPhoneNumber(), ouCode: 'LS'},
  //     accessToken: getAccessToken(),
  //   };
  //   dispatch(fetchOffers(parameters));
  // }, []);

  useEffect(() => {
    const couponPointsDataFromLocalStorage = getWithExpiry(
      'coupon_point_details',
    );
    let updateMyOffers;
    let allOffers: any[];
    if (couponPointsDataFromLocalStorage !== null) {
      // if (myOffers !== null) {
      //   updateMyOffers = myOffers.map(offer => {
      //     return {
      //       ...offer,
      //       description: offer.couponDesc,
      //       validity: offer.validTillDate,
      //     };
      //   });
      // }
      // if (updateMyOffers) {
      // allOffers = [...couponPointsDataFromLocalStorage, ...updateMyOffers];
      // } else {
      allOffers = [...couponPointsDataFromLocalStorage];
      // }
      allOffers.sort((a, b) => (a.validity > b.validity ? 1 : -1));
      const updatedOffers = allOffers.map(offer => {
        if (offer.description.includes('_.')) {
          const description = offer.description.split('_.')[1].trim();
          return {...offer, description};
        }
        return offer;
      });
      setAllOffers(updatedOffers);
      setAllCoupons(updatedOffers);
    } else {
      if (myOffers !== null) {
        updateMyOffers = myOffers.map(offer => {
          return {
            ...offer,
            description: offer.couponDesc,
            validity: offer.validTillDate,
          };
        });
      }
      if (updateMyOffers) {
        allOffers = [...updateMyOffers];
      } else {
        allOffers = [];
      }
      if (allOffers.length > 0) {
        allOffers.sort((a, b) => (a.validity > b.validity ? 1 : -1));
        const updatedOffers = allOffers.map(offer => {
          if (offer.description.includes('_.')) {
            const description = offer.description.split('_.')[1].trim();
            return {...offer, description};
          }
          return offer;
        });
        setAllOffers(updatedOffers);
        setAllCoupons(updatedOffers);
      }
    }
  }, [myOffers]);

  function handleOfferClick(offer: any) {
    setShowUnlockedModel(true);
    setUnlockedOffer(offer);
  }

  function handleScanButtonClick() {
    navigate.push('/home/offers');
  }
  return (
    <div className="p-4">
      <div className="font-roboto text-center tracking-tight leading-tight">
        Continue scanning QR codes and avail offers specially curated for you on
        the go!
      </div>
      <div className="my-6">
        <button
          onClick={handleScanButtonClick}
          className="cursor-none-allowed text-white h-14 rounded-xl border-solid border border-gray-400 mt-2 grid place-items-center focus:outline-none  w-full text-center primary normal">
          <p className="font-bold font-roboto">Scan QR for more offers</p>
        </button>
      </div>
      <OfferCard offers={allCoupons} onClick={handleOfferClick} />
      {unlockedOffer !== null && showUnlockedModel === true && (
        <OfferModal
          open={showUnlockedModel}
          offer={unlockedOffer}
          onClose={() => {
            setShowUnlockedModel(false);
          }}
        />
      )}
    </div>
  );
};

export default Offers;
